import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProfileImage from "../account/ProfileImage";
import { getProfilePic, getSmartProfileUrl } from "../../services/apiService";
import { useDarkMode } from "../commons/DarkMode/useDarkMode";
import { useUser } from "./UserContext";
import { NotificationBell } from "../notifications";

interface ProfileIconProps {
  // Kept for API compatibility with AuthenticationButton. Sign-out now lives
  // in the AppNav menu — the avatar no longer opens a dropdown.
  onSignOut: () => void;
}

const ProfileIcon: React.FC<ProfileIconProps> = () => {
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const { user } = useUser();

  useDarkMode();

  const userProfilePic = getProfilePic();
  const imageUrl =
    userProfilePic && "null" !== userProfilePic
      ? userProfilePic
      : "https://storage.googleapis.com/assestsbookiebrawler/icons/profile-default.png";

  // The avatar is a direct link to the user's own public profile — no
  // dropdown. Sign-out / settings live in the AppNav menu.
  const profileUrl =
    user && user.id !== 0 ? getSmartProfileUrl(user) : "/account-settings";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {/* Top-bar bell: always on desktop. On phones/tablets, app-nav.css
          hides it only while BottomNav is mounted (html.bb-has-bottomnav) —
          Alerts live in that bar. When the bar is down (landing, admin),
          this bell stays so notifications are still reachable. */}
      <span className="bb-topbar-bell">
        <NotificationBell
          open={notificationsOpen}
          onOpenChange={setNotificationsOpen}
        />
      </span>
      <Link
        to={profileUrl}
        className="on-dropdown"
        aria-label="View your public profile"
        style={{ display: "inline-flex", alignItems: "center" }}
      >
        <ProfileImage imageUrl={imageUrl} size={40} />
      </Link>
    </div>
  );
};

export default ProfileIcon;
